module.exports = __webpack_public_path__ + "img/arrow_left.ea239ab5.svg";